import _throttle from 'lodash/throttle'
import EventBus from '@/eventBus'
import Constants from '@/constant'
import Utils from '@/util'
import store from '@/vuex/store'

const MESSAGE_TYPES = {
  QUIZ_POLL_ANSWER: 'a',
  QUESTION: 'question-and-answer',
  SCALE: 'sca',
}

function _resetTempAudienceCount(editor, doc) {
  if (!editor.slideActive.multipleCountAnswer) {
    if (editor.slideActive.id != doc.s) {
      //
    } else {
      editor.updateSlideActiveAction({
        multipleCountAnswer: 0,
      })
      editor.$store.state.tempAudienceCount = 0
    }
  }
}

function updateVoteCount(editor, doc, index) {
  const { s: slideId } = doc
  const payload = {
    id: slideId,
    multipleCountAnswer: editor.$store.state.tempAudienceCount,
  }
  if (index !== null) {
    payload.multipleCountAnswer = editor.presentation.slides[index].voteCache
  }

  editor.patchSlideByIdAction(payload)
}

function _checkEveryoneVotedQuiz(editor) {
  if (editor.$store.state.slideActive.type !== 'pickAnswer') {
    return
  }
  if (editor.$store.state.slideActive.quizStatus !== Constants.QuizStatuses.QUESTION_SCREEN) {
    return
  }

  let someoneHaveNotVote = false

  Object.keys(editor.$store.state.audiences).forEach((key) => {
    const audience = editor.$store.state.audiences[key]
    const audienceNotAnswer = !audience[editor.$store.state.slideActive.id]
    if (audienceNotAnswer) {
      someoneHaveNotVote = true
    }
  })
  if (!someoneHaveNotVote) {
    EventBus.$emit('everyone-voted')
  }
}

const updateVoteCountThrottle = _throttle(updateVoteCount, 250)

function _updateQuestionAnswer(editor, question) {
  const index = editor.$store.state.questions.findIndex((item) => {
    return item.id == question.id
  })
  if (index === -1) {
    editor.$store.state.questions.push(question)
  } else {
    editor.$store.state.questions[index] = question
  }
  const arr = JSON.parse(JSON.stringify(editor.$store.state.questions))
  Utils.updateDataQuestionAnswer(arr, editor.$store.state.tabQnaQuestion)
}

function _updateSlideOptions(editor, doc) {
  const { s: slideId, v: votedSlideOptionIds } = doc

  const matchSlide = editor.presentation.slides.find((slide) => slide.id === slideId)
  if (!matchSlide) return

  const newSlideOptions = matchSlide.SlideOptions.map((slideOption) => {
    const hasVoted = votedSlideOptionIds.some((item) => item === slideOption.id)

    if (hasVoted) {
      const currentCount = slideOption.count || 0
      return {
        ...slideOption,
        count: currentCount + 1,
      }
    }

    return slideOption
  })

  editor.patchSlideByIdAction({
    id: slideId,
    SlideOptions: newSlideOptions,
  })
}

function handleParticipantAnswer(doc, editor) {
  if (store.getters['featureToggles/canUsePollEmqx']) {
    return
  }

  let indexSlideVote = null

  if (doc.s != editor.slideActive.id) {
    const indexSlideInPresentation = editor.presentation.slides.findIndex((item) => {
      return item.id == doc.s
    })

    if (indexSlideInPresentation !== -1) {
      indexSlideVote = indexSlideInPresentation
    }
  }

  if (doc.iTa) {
    _resetTempAudienceCount(editor, doc)
    if (indexSlideVote === null) {
      editor.$store.state.tempAudienceCount++
      updateVoteCountThrottle(editor, doc, null)
    } else {
      editor.$store.state.presentation.slides[indexSlideVote].voteCache++
      updateVoteCountThrottle(editor, doc, indexSlideVote)
    }

    if (!editor.sharePresentation && editor.slideActive.type == 'pickAnswer') {
      if (editor.userOnline < 30) {
        if (editor.$store.state.audiences[doc.a]) {
          editor.$store.state.audiences[doc.a][doc.s] = true
          _checkEveryoneVotedQuiz(editor)
        }
      }
    }
    return
  }

  if (doc.v && doc.v.length) {
    _resetTempAudienceCount(editor, doc)

    if (indexSlideVote === null) {
      editor.$store.state.tempAudienceCount++
      updateVoteCountThrottle(editor, doc, null)
    } else {
      editor.$store.state.presentation.slides[indexSlideVote].voteCache++

      updateVoteCountThrottle(editor, doc, indexSlideVote)
    }

    _updateSlideOptions(editor, doc)
    if (editor.presentation.audiencePacing) {
      // update chart whenever audience answers
      editor.$store.dispatch('updateSlideActive', editor.slideActive)
    }

    if (!editor.sharePresentation && editor.slideActive.type == 'pickAnswer') {
      if (editor.userOnline < 30) {
        if (editor.$store.state.audiences[doc.a]) {
          editor.$store.state.audiences[doc.a][doc.s] = true
          _checkEveryoneVotedQuiz(editor)
        }
      }
    }
  }
}

function handleParticipantQuestion(doc, editor) {
  if (doc.action == 'create') {
    if (!editor.presentation.isModerationMode) {
      const arr = JSON.parse(JSON.stringify(editor.$store.state.questions))
      arr.push(doc.data)
      Utils.updateDataQuestionAnswer(arr, editor.$store.state.tabQnaQuestion)
      EventBus.$emit('questionAnimationAction')
    } else {
      editor.$store.state.questions.push(doc.data)
    }
    Utils.mixpanelTracking('Question And Answer', 'Question Received', 'Question Received')
  } else if (doc.action == 'vote' || doc.action === 'question-updated') {
    _updateQuestionAnswer(editor, doc.data)
  }
}

const _handleAudienceScaleQuestionThrottled = _throttle(() => {
  EventBus.$emit('scaleQuestionAnswer')
}, 1000)

const updateVoteCountForScaleThrottle = _throttle((editor) => {
  editor.updateSlideActiveAction({
    multipleCountAnswer: editor.$store.state.tempAudienceCount,
  })
}, 250)

function handleScaleAnswer(doc, editor) {
  _resetTempAudienceCount(editor, doc)
  editor.$store.state.tempAudienceCount++
  _handleAudienceScaleQuestionThrottled()
  updateVoteCountForScaleThrottle(editor)
}

const AnswerWebsocketSubscriber = {
  [MESSAGE_TYPES.QUIZ_POLL_ANSWER]: handleParticipantAnswer,
  [MESSAGE_TYPES.QUESTION]: handleParticipantQuestion,
  [MESSAGE_TYPES.SCALE]: handleScaleAnswer,
}

export default AnswerWebsocketSubscriber
